'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitBoxProps;

var _enhancers = require('../enhancers');

var _splitProps = require('./split-props');

var _splitProps2 = _interopRequireDefault(_splitProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convenience method to split the Box props.
 *
 * Useful for when you want to pass all of the Box props to the root Box and
 * pass the remaining props to a child element (e.g: disabled, readOnly, required, etc).
 */
function splitBoxProps(props) {
  return (0, _splitProps2.default)(props, _enhancers.propNames);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9zcGxpdC1ib3gtcHJvcHMuanMiXSwibmFtZXMiOlsic3BsaXRCb3hQcm9wcyIsInByb3BzIiwicHJvcE5hbWVzIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFTd0JBLGE7O0FBVHhCOztBQUNBOzs7Ozs7QUFFQTs7Ozs7O0FBTWUsU0FBU0EsYUFBVCxDQUF1QkMsS0FBdkIsRUFBOEI7QUFDM0MsU0FBTywwQkFBV0EsS0FBWCxFQUFrQkMsb0JBQWxCLENBQVA7QUFDRCIsImZpbGUiOiJzcGxpdC1ib3gtcHJvcHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge3Byb3BOYW1lc30gZnJvbSAnLi4vZW5oYW5jZXJzJ1xuaW1wb3J0IHNwbGl0UHJvcHMgZnJvbSAnLi9zcGxpdC1wcm9wcydcblxuLyoqXG4gKiBDb252ZW5pZW5jZSBtZXRob2QgdG8gc3BsaXQgdGhlIEJveCBwcm9wcy5cbiAqXG4gKiBVc2VmdWwgZm9yIHdoZW4geW91IHdhbnQgdG8gcGFzcyBhbGwgb2YgdGhlIEJveCBwcm9wcyB0byB0aGUgcm9vdCBCb3ggYW5kXG4gKiBwYXNzIHRoZSByZW1haW5pbmcgcHJvcHMgdG8gYSBjaGlsZCBlbGVtZW50IChlLmc6IGRpc2FibGVkLCByZWFkT25seSwgcmVxdWlyZWQsIGV0YykuXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNwbGl0Qm94UHJvcHMocHJvcHMpIHtcbiAgcmV0dXJuIHNwbGl0UHJvcHMocHJvcHMsIHByb3BOYW1lcylcbn1cbiJdfQ==